import { z } from "zod";

import { branded } from "@/lib/helpers/branded-helper.ts";

export const momboxHardwareVersionSchema = z.object({
  id: z.number(),
  description: z.string(),
  v2V5: z.boolean(),
  vx: z.boolean(),
});

export const momboxDtoSchema = z.object({
  confSoftwareId: z.number().nullable(),
  csId: branded.pilotCsId,
  hwId: branded.pilotHwId,
  lastIpDate: z.coerce.date().nullable(),
  location: z.string().nullable(),
  operator: z.string().nullable(),
  refOperatingStatus: z.number().nullable(),
  serialNumber: branded.serialNumber,
  siteId: branded.siteId.nullable(),
  softwareVersion: z.string(),
  actionToBeTaken: z.string(),
  updating: z.boolean(),
  momboxHardwareVersion: momboxHardwareVersionSchema.optional(),
});

export type TMomboxDto = z.infer<typeof momboxDtoSchema>;
